export const INVOICE_STATUS_BADGE_COLORS: Record<string, string> = {
  'Paid': 'bg-green-100 text-green-800',
  'Received': 'bg-yellow-100 text-yellow-800',
  'Issued': 'bg-blue-100 text-blue-800',
  'Overdue': 'bg-red-100 text-red-800',
  'Partially Paid': 'bg-amber-100 text-amber-800',
  'Requested': 'bg-orange-100 text-orange-800',
  'Not Issued': 'bg-gray-100 text-gray-700',
  'Not Requested': 'bg-gray-100 text-gray-700',
  'Cancelled': 'bg-gray-100 text-gray-500',
  'Unpaid': 'bg-red-100 text-red-800',
  'Scheduled': 'bg-blue-50 text-blue-700',
};

export const INVOICE_STATUS_TEXT_COLORS: Record<string, string> = {
  'Paid': 'text-green-700',
  'Received': 'text-yellow-700',
  'Issued': 'text-blue-700',
  'Overdue': 'text-red-700',
  'Partially Paid': 'text-amber-700',
  'Requested': 'text-orange-700',
  'Not Issued': 'text-gray-600',
  'Not Requested': 'text-gray-600',
  'Cancelled': 'text-gray-500',
  'Unpaid': 'text-red-700',
  'Scheduled': 'text-blue-700',
};

export function getInvoiceStatusBadgeColor(status: string): string {
  return INVOICE_STATUS_BADGE_COLORS[status] || 'bg-gray-100 text-gray-700';
}

export function getInvoiceStatusTextColor(status: string): string {
  return INVOICE_STATUS_TEXT_COLORS[status] || 'text-gray-600';
}
